import React, { useEffect, useState } from "react";

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Set loaded state after component mounts
    setIsLoaded(true);

    // Hide default cursor when custom cursor is loaded
    document.body.style.cursor = 'none';

    const updatePosition = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    const handleMouseOver = (e) => {
      const target = e.target;
      if (
        target.tagName === "A" ||
        target.tagName === "BUTTON" ||
        target.getAttribute("role") === "button" ||
        target.closest("a") ||
        target.closest("button")
      ) {
        setIsHovering(true);
      } else {
        setIsHovering(false);
      }
    };

    window.addEventListener("mousemove", updatePosition);
    window.addEventListener("mouseover", handleMouseOver);

    return () => {
      // Restore default cursor when component unmounts
      document.body.style.cursor = 'auto';
      window.removeEventListener("mousemove", updatePosition);
      window.removeEventListener("mouseover", handleMouseOver);
    };
  }, []);

  // Don't render custom cursor if not loaded
  if (!isLoaded) return null;

  return (
    <>
      {/* Main cursor (white pointer shape) */}
      <div
        style={{
          position: "fixed",
          left: `${position.x}px`,
          top: `${position.y}px`,
          transform: `translate(-50%, -50%) scale(${isHovering ? 1.2 : 1})`,
          pointerEvents: "none",
          zIndex: 99999,
          transition: "transform 0.15s ease-out",
        }}
      >
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="white"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            filter: "drop-shadow(0 2px 2px rgba(0,0,0,0.2))",
          }}
        >
          <path
            d="M5.5 3.5L19.5 12L12 13.5L8.5 20L5.5 3.5Z"
            stroke="black"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {/* Trailing glow effect */}
      <div
        style={{
          position: "fixed",
          left: `${position.x}px`,
          top: `${position.y}px`,
          transform: `translate(-50%, -50%) scale(${isHovering ? 1.2 : 0.8})`,
          pointerEvents: "none",
          zIndex: 99998,
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(14, 205, 248, 0.4), rgba(230, 26, 142, 0.2), transparent)",
          transition: "transform 0.4s ease-out, opacity 0.4s ease-out",
          opacity: 0.7,
        }}
      />
    </>
  );
};

export default CustomCursor;
